module.exports = __webpack_public_path__ + "static/img/reward-coin-standard.f083755.png";